import type { ButtonHTMLAttributes } from "react";
import MaterialIcon, { type IconName } from "./MaterialIcon";

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children" | "title"> {
  icon: IconName;
  /** Names the button for screen readers and shows instantly on hover. */
  label: string;
}

// An icon-only button. The tooltip comes from `data-tip` via TooltipHost,
// which shows at once; the native title attribute waits about a second.
export default function IconButton({ icon, label, className = "", type = "button", ...rest }: Props) {
  return (
    <button type={type} className={`btn icon-btn ${className}`} aria-label={label} data-tip={label} {...rest}>
      <MaterialIcon name={icon} />
    </button>
  );
}
